/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { ChangeDetectionStrategy, Component, Inject, InjectionToken, signal } from '@angular/core';

export const TOOLTIP_DATA = new InjectionToken<any>('TOOLTIP_DATA');
@Component({
    selector: 'nova-multi-line-custom-tooltip',
    template: `<div
        class="custom-tooltip"
        role="tooltip">
        @for (line of lines(); track $index) {
            <div [innerHTML]="line"></div>
        }
    </div>`,
    styleUrls: ['./multi-line-custom-tooltip.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultiLineCustomTooltipComponent {
    lines = signal<string[]>([]);

    constructor(@Inject(TOOLTIP_DATA) public data: any) {
        if (data?.text) {
            const formattedLines = data.text.split(/(?<=\.)/).map((line) => {
                const parts = line.split(':');
                if (parts.length === 2) {
                    return `<span style="font-weight: bold;">${parts[0]}</span>: ${parts[1]}<br></br>`;
                } else {
                    return line;
                }
            });
            this.lines.set(formattedLines);
        }
    }
}
